import PlayCtaButton from '@/components/common/PlayCtaButton';

export default function CtaSection() {
  return (
    <section className="relative flex items-center justify-center px-6 py-24 sm:py-32 overflow-hidden">
      {/* Radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_50%_at_50%_50%,hsl(var(--accent-gold)/0.04),transparent_70%)]" />
      <div
        className="absolute bottom-4 left-0 right-0 h-px"
        style={{
          background:
            'linear-gradient(to right, transparent, hsl(var(--accent-gold) / 0.3), transparent)',
        }}
      />

      <div className="relative z-10 mx-auto max-w-2xl text-center flex flex-col items-center gap-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-character text-foreground">
          Ready? Begin Your Adventure
        </h2>

        <PlayCtaButton label="Start Playing" />
      </div>
    </section>
  );
}
